module.exports = __webpack_public_path__ + "img/sld_scb_18_t1_b1.d2b1629d.svg";